import KASKIDA from '../../includes/primitives/_constant_kaskida'
import TRION from '../../includes/primitives/_constant_trion'
import DEMO from '../../includes/primitives/_constant_demo'
import GOLDEN from '../../includes/primitives/_constant_gpl'

import * as d3 from 'd3'
export default {

  data: () => ({
    HOST_KASKIDA: KASKIDA.HOST_NAME_RESOURCE + '/resources/',
    HOST_TRION: TRION.HOST_NAME_RESOURCE + '/resources/',
    HOST_DEMO: DEMO.HOST_NAME_RESOURCE + '/resources/',
    HOST_GOLDEN: GOLDEN.HOST_NAME_RESOURCE + '/resources/',
  }),

  methods: {

    gmx_Sundries(selection, sundriesList, data, server) {
      // console.log(dataset)
      this.app_Colors()
      
      sundriesList.forEach((d, idx)=> {
        switch(d.type) {

          // Texts
          case 'texts-Std':         this.app_Text_Std(selection, idx, data, d);         break
          case 'values-Std':        this.app_Values_Std(selection, idx, data, d);       break
          case 'values-Unit':       this.app_Values_Unit(selection, idx, data, d);      break
          case 'text-Wrap':         this.app_wrapText(selection, idx, data, d);         break

          // Images
          case 'svg':               this.app_SVG(selection, idx, data, d, server);      break
          case 'image':             this.app_Images(selection, idx, data, d, server);   break
          case 'exLink':            this.app_exLink(selection, idx, data, d, server);   break
          case 'help':              this.app_Help(selection, idx, data, d, server);     break

          // Graphics
          case 'lines':             this.app_Lines(selection, idx, data, d);            break
          case 'rects':             this.app_Rectangles(selection, idx, data, d);       break

          // bar Chart
          case 'bars-Hoz-Std':      this.app_bars_Hoz_Std(selection, idx, data, d);     break
        }
      })
      
    },






    app_Colors() {
      this.gmx_ColorH2Sets()
      this.gmx_ColorV2Sets()
    },
    

    
  }
}
